/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum JobApplicationStatus {
  Triage = "triage",
  Reviewing = "reviewing",
  InterviewWanted = "interview_wanted",
  InterviewScheduled = "interview_scheduled",
  Hired = "hired",
  Future = "future",
  Rejected = "rejected",
}

export function instanceOfJobApplicationStatus(value: any): boolean {
  for (const key in JobApplicationStatus) {
    if (Object.prototype.hasOwnProperty.call(JobApplicationStatus, key)) {
      if (
        JobApplicationStatus[key as keyof typeof JobApplicationStatus] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function JobApplicationStatusFromJSON(json: any): JobApplicationStatus {
  return JobApplicationStatusFromJSONTyped(json, false);
}

export function JobApplicationStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): JobApplicationStatus {
  return json as JobApplicationStatus;
}

export function JobApplicationStatusToJSON(
  value?: JobApplicationStatus | null,
): any {
  return value as any;
}

export function JobApplicationStatusToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): JobApplicationStatus {
  return value as JobApplicationStatus;
}
